import { Tag } from "../../../../common/components/common/Tag/Tag";
import { SkeletonItem } from "../../../../common/components/skeletons/SkeletonItem";
import { Icon, IconType } from "../../../../common/icons/Icon";
import { dateUtility } from "../../../../common/infrastructure/utilities/dateUtility";
import { bg } from "date-fns/locale";
import { ConsentPolicyTypeLabels } from "../../../../common/labels";
import { IUserConsentViewModel } from "../models/userConsentViewModel";
import styles from "./ConsentItem.module.scss";
import { classNames } from "primereact/utils";

interface IConsentItemProps {
  item?: IUserConsentViewModel;
  isLoading: boolean;
  onClick: (consentId: number) => void;
}

export const ConsentItem = ({
  item,
  isLoading,
  onClick,
}: IConsentItemProps) => {
  const consentTypeName = item ? ConsentPolicyTypeLabels[item.type] : "";

  return (
    <div
      className={classNames(styles.root)}
      onClick={() => (item?.consentId ? onClick(item.consentId) : () => {})}
    >
      <div className={styles.root_left_section}>
        <SkeletonItem
          isLoading={isLoading}
          width={200}
          value={
            <div className={styles.root_left_section_title}>
              {consentTypeName}
            </div>
          }
        />
        <SkeletonItem
          isLoading={isLoading}
          width={300}
          value={
            <div
              className={classNames(
                styles.root_left_section_item,
                styles.root_left_section_item_sub,
              )}
            >
              <Tag
                backgroundColor={"#f5aa89"}
                label={
                  <span className={styles.tag}>
                    Версия:{" "}
                    {dateUtility.formatDate(
                      item?.policyCreatedOn,
                      "dd.MM.yyyy",
                      bg,
                    )}
                  </span>
                }
              />
              {item?.givenAt === null && item?.requiresSignature ? (
                <Tag
                  backgroundColor={"#e74c3c"}
                  className={styles.tag}
                  label={<span className={styles.tag}>Изисква съгласие</span>}
                />
              ) : item?.givenAt === null && !item?.requiresSignature ? (
                <Tag
                  backgroundColor={"#f39c12"}
                  className={styles.tag}
                  label={
                    <span className={styles.tag}>Незадължително съгласие</span>
                  }
                />
              ) : item?.givenAt ? (
                <Tag
                  backgroundColor={"#8082f0ff"}
                  className={styles.tag}
                  label={
                    <span className={styles.tag}>
                      Дадено съгласие на:{" "}
                      {dateUtility.formatDate(
                        item.givenAt,
                        "dd.MM.yyyy HH:mm",
                        bg,
                      )}
                    </span>
                  }
                />
              ) : null}
            </div>
          }
        />
      </div>
      <div className={styles.root_right_section}>
        <Icon type={IconType.RightChevronIcon} />
      </div>
    </div>
  );
};
